export default "__VITE_ASSET__DUGkRG6d__"